import { render, staticRenderFns } from "./SelectSteuersatz.vue?vue&type=template&id=3459481a&scoped=true&"
import script from "./SelectSteuersatz.vue?vue&type=script&lang=js&"
export * from "./SelectSteuersatz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459481a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/mwst-rechner-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VLayout,VMenu,VSelect})
